export const SAVE_TOKENS = "SAVE_TOKENS";
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const SAVE_USER_DETAILS = "SAVE_USER_DETAILS";
export const CAM_PERMISSIONS = "CAM_PERMISSIONS";
export const inititive = "inititive";
